var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isOrgAdmin)?_c('router-view',{key:_vm.$route.name}):_c('empty-page',{attrs:{"type":"permission"}}),_c('i-toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }